<div class="d-md-flex content">
    <div class="col-5" >
        <div class="timeline">
            <div *ngFor='let item of updates | splitStrings; let i = index'>
              <div class="container cr-pointer" (click)="textDefault = item.content" [ngClass]="{ left: i%2!==0, right:i%2==0}">
                <div class="content-1">
                  <p class="text-1">{{item.title}}</p>
                  <p class="text-2">{{item.subtitle}}</p>
                </div>
              </div>
            </div>
        </div>
    </div>
    <div class="col-7 align-content-center" *ngIf="!isSessionActive">
        <div class="content-2 p-5 animated fadeIn">
          <div >
             <p class="text-center mb-3 fs-18"><strong>Contenido exclusivo: Reportes periódicos</strong></p>

            <p class="text-start mt-3 fs-15">Este contenido está reservado para los inversionistas del proyecto. Para acceder a los reportes detallados de pagos y rendimientos, por favor, 
              <a class="text-decoration-underline cl-primary fw-bold" href="https://app.monific.com" target="_blank"> Inicia sesión </a>
              o 
              <a class="text-decoration-underline cl-primary fw-bold" href="https://app.monific.com/registro" target="_blank"> Regístrate.</a>
            </p>
          </div>
        </div>
    </div>
</div>
    